import { render, staticRenderFns } from "./clientdownload.vue?vue&type=template&id=50903c81&scoped=true&"
import script from "./clientdownload.vue?vue&type=script&lang=js&"
export * from "./clientdownload.vue?vue&type=script&lang=js&"
import style0 from "./clientdownload.vue?vue&type=style&index=0&id=50903c81&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50903c81",
  null
  
)

export default component.exports